var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"my-app home-two-dark"},[_c('Header2',{staticClass:"header--dark"}),_vm._v(" "),_c('MobileMenu'),_vm._v(" "),_c('div',{staticClass:"mobile-menu__backdrop"}),_vm._v(" "),_c('PageHeader',{attrs:{"page-title":"Sobre Neuro"}}),_vm._v(" "),_c('Introduction'),_vm._v(" "),_c('Footer2')],1),_vm._v(" "),_c('BackToTop')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10963f50","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = null
// module chunks = 